import { getEncryptedText } from "../../services/liferay/AllServicesOtherDashboard";

const OtherServicesCard = ({ index, userServices, translationMap }) => {
  let baseURL = userServices.url;
  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    // window.parent.location.reload(true);
  };

  const handleClick = async (e) => {
    e.preventDefault();
    clearCacheData();
    if (userServices.persona !== "default") {
      const encryptedUrl = await getEncryptedText(userServices.mappingServiceId, userServices.persona, userServices.language);
      baseURL += encryptedUrl.data.url;
    }
    window.location.href = baseURL;
  };
  // const serviceClass = userServices?.title
  //     ? userServices.title.toLowerCase().replace(/\s+/g, "-")
  //     : "";
  const serviceClass = userServices?.title ? userServices.title
  .toLowerCase()
  .replace(/['()]/g, "")
  .replace(/\s+/g, "-")
  .replace(/[^a-z0-9-]/g, "") : "";

  return <>
        <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="serviceDashboardCard">
                <div className="serviceDashboardCardInner">
                    <div className="servicecontentbox">
                        <h4>{userServices.title}</h4>
                        <p>{userServices.shortDescription}</p>
                    </div>
                    <div className={`serviceDashboardCardBtn ${serviceClass}`}>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
              href="#"
              className="btn2 btnNavyClr btnSm"
              onClick={handleClick}>
              
                            {translationMap?.startService}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default OtherServicesCard;